export const PAGE_TYPE_CREATE_QUOTE = 'CREATE_QUOTE';
export const PAGE_TYPE_UPDATE_QUOTE = 'UPDATE_QUOTE';
